/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

export class EntityFollowing {

  static readonly DANCERS = 'dancers';
  static readonly STUDIOS = 'studios';

  constructor(public entityType: string, public id: string, public entityId: string, public name: string = null) {

  }

  static fromSnapshotList(snapshot: any) : EntityFollowing[] {
    if (snapshot.key == this.DANCERS) {
      return this._fromDancersFollowingSnapshot(snapshot.val());
    } else if (snapshot.key == this.STUDIOS) {
      return this._fromStudiosFollowingSnapshot(snapshot.val());
    }
  }

  private static _fromDancersFollowingSnapshot(snap: any) : EntityFollowing[] {
    let ids = Object.keys(snap);
    return ids.map(id => new EntityFollowing(this.DANCERS, id, snap[id].studioKey, snap[id].name));
  }

  private static _fromStudiosFollowingSnapshot(snap: any) : EntityFollowing[] {
    let ids = Object.keys(snap);
    return ids.map(id => new EntityFollowing(this.STUDIOS, id, id, snap[id].name));
  }
}



// WEBPACK FOOTER //
// ./src/models/following/EntityFollowing.ts